<template>
  <div class="group-management">
    <h2>Gerenciamento de Grupos</h2>
    <div class="btn-group">
      <button @click="goBack" class="back-button">Voltar para Administração</button>
      <button @click="gerarJogos" class="generate-games-button">Gerar Jogos da Etapa</button>
    </div>
    <div class="form-container">
      <label for="stage">Etapa:</label>
      <select v-model="selectedStageId" @change="loadGroups">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }}
        </option>
      </select>
      <input type="text" v-model="newGroupName" placeholder="Nome do grupo"/>
      <button @click="createGroup" class="create-button">Criar Grupo</button>
    </div>
    <draggable v-model="groups"
               item-key="id"
               @end="onGroupDragEnd"
               class="group-list"
    >
    <template #item="{element: group}">
      <div class="group-block">
        <div class="group-item">
          <span>{{ group.name }}</span>
          <div class="group-actions">
            <button @click="confirmDeleteGroup(group.id)" class="delete-button">Deletar</button>
            <button @click="selectGroup(group.id)" class="view-button">Ver Grupo</button>
            <button @click="confirmGenerateGames(group.id)" class="generate-button">Gerar Jogos</button>
            <button @click="confirmDeleteGames(group.id)" class="delete-games-button">Limpar Jogos</button>
          </div>
        </div>
        <transition name="fade-expand">
          <div v-if="expandedGroupId === group.id && !loadingGroupDetails" class="group-details">
            <h3>Jogadores do Grupo</h3>
            <draggable v-model="groupPlayers"
                       item-key="id"
                       @end="onDragEnd"
                       class="player-list"
            >
              <template #item="{ element }">
                <li class="player-item">
                  <span class="drag-handle">☰</span>
                  {{ element.User.fullName }}
                  <button @click="confirmRemovePlayer(element.id)" class="remove-button">Remover</button>
                </li>
              </template>
            </draggable>
            <h3>Adicionar Jogador ao Grupo</h3>
            <div class="add-player-container">
              <select v-model="selectedPlayerId" class="player-select">
                <option v-for="player in players" :key="player.id" :value="player.id">
                  {{ player.User.fullName }}
                </option>
              </select>
              <button @click="addPlayer" class="add-button">Adicionar</button>
            </div>
          </div>
        </transition>
      </div>
    </template>
    </draggable>
<!--    <div class="group-list">-->
<!--      <div v-for="group in groups" :key="group.id" class="group-block">-->
<!--        <div class="group-item">-->
<!--          <span>{{ group.name }}</span>-->
<!--          <div class="group-actions">-->
<!--            <button @click="confirmDeleteGroup(group.id)" class="delete-button">Deletar</button>-->
<!--            <button @click="selectGroup(group.id)" class="view-button">Ver Grupo</button>-->
<!--            <button @click="confirmGenerateGames(group.id)" class="generate-button">Gerar Jogos</button>-->
<!--            <button @click="confirmDeleteGames(group.id)" class="delete-games-button">Limpar Jogos</button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <transition name="fade-expand">-->
<!--          <div v-if="expandedGroupId === group.id && !loadingGroupDetails" class="group-details">-->
<!--            <h3>Jogadores do Grupo</h3>-->
<!--            <draggable v-model="groupPlayers"-->
<!--                       item-key="id"-->
<!--                       @end="onDragEnd"-->
<!--                       class="player-list"-->
<!--            >-->
<!--              <template #item="{ element }">-->
<!--                <li class="player-item">-->
<!--                  <span class="drag-handle">☰</span>-->
<!--                  {{ element.User.fullName }}-->
<!--                  <button @click="confirmRemovePlayer(element.id)" class="remove-button">Remover</button>-->
<!--                </li>-->
<!--              </template>-->
<!--            </draggable>-->
<!--            <h3>Adicionar Jogador ao Grupo</h3>-->
<!--            <div class="add-player-container">-->
<!--              <select v-model="selectedPlayerId" class="player-select">-->
<!--                <option v-for="player in players" :key="player.id" :value="player.id">-->
<!--                  {{ player.User.fullName }}-->
<!--                </option>-->
<!--              </select>-->
<!--              <button @click="addPlayer" class="add-button">Adicionar</button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </transition>-->
<!--      </div>-->
<!--    </div>-->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <p>{{ modalMessage }}</p>
        <button @click="confirmAction" class="confirm-button">Confirmar</button>
        <button @click="cancelAction" class="cancel-button">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import groupService from '../services/groupService';
import stageService from '../services/stageService';
import playerService from '../services/playerService';
import gameService from '../services/gameService';
import groupPlayerService from "@/services/groupPlayerService";

export default {
  components: {
    draggable
  },
  data() {
    return {
      stages: [],
      groups: [],
      players: [],
      groupPlayers: [],
      selectedStageId: null,
      selectedPlayerId: null,
      newGroupName: '',
      showModal: false,
      modalMessage: '',
      actionToConfirm: null,
      actionData: null,
      expandedGroupId: null,
      loadingGroupDetails: false,
    };
  },
  created() {
    this.loadStages();
  },
  methods: {
    async loadStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[this.stages.length - 1].id;
          await this.loadGroups();
        }
      } catch (error) {
        console.error('Erro ao buscar etapas:', error);
      }
    },
    async createGroup() {
      const group = {
        name: this.newGroupName,
        stageId: this.selectedStageId,
      };
      try {
        await groupService.createGroup(group);
        await this.loadGroups();
        this.newGroupName = '';
      } catch (error) {
        console.error('Erro ao criar grupo:', error);
      }
    },
    async loadGroups() {
      if (this.selectedStageId) {
        try {
          const response = await groupService.getGroupsByStage(this.selectedStageId);
          this.groups = response.data;
        } catch (error) {
          console.error('Erro ao buscar grupos:', error);
        }
      }
    },
    async loadPlayers() {
      try {
        const response = await playerService.getAllPlayers();
        this.players = response.data;
      } catch (error) {
        console.error('Erro ao buscar jogadores:', error);
      }
    },
    async deleteGroup(groupId) {
      try {
        await groupService.deleteGroup(groupId);
        await this.loadGroups();
      } catch (error) {
        console.error('Erro ao deletar grupo:', error);
      }
    },
    async selectGroup(groupId) {
      if (this.expandedGroupId === groupId) {
        this.expandedGroupId = null;
      } else {
        this.loadingGroupDetails = true;
        const response = await this.loadPlayersInGroup(groupId)
        if (response){
          this.expandedGroupId = groupId;
        }
        this.loadingGroupDetails = false;
      }
    },
    async addPlayer() {
      try {
        await groupService.addPlayerToGroup(this.expandedGroupId, this.selectedPlayerId);
        await this.loadPlayersInGroup(this.expandedGroupId);
        alert('Jogador adicionado ao grupo com sucesso');
      } catch (error) {
        console.error('Erro ao adicionar jogador ao grupo:', error);
      }
    },
    async loadPlayersInGroup(groupId) {
      try {
        const response = await groupService.getPlayersByGroup(groupId);
        this.groupPlayers = response.data;
        return true;
      } catch (error) {
        console.error('Erro ao buscar jogadores do grupo:', error);
        return false;
      }
    },
    async removePlayer(playerId) {
      try {
        await groupService.removePlayerFromGroup(this.expandedGroupId, playerId);
        await this.loadPlayersInGroup();
        alert('Jogador removido do grupo com sucesso');
      } catch (error) {
        console.error('Erro ao remover jogador do grupo:', error);
      }
    },
    async generateGames(groupId) {
      try {
        await gameService.generateGamesForGroup(groupId, this.selectedStageId);
        alert('Jogos gerados com sucesso');
      } catch (error) {
        console.error('Erro ao gerar jogos', error);
      }
    },
    async deleteGames(groupId) {
      try {
        await gameService.deleteGamesForGroup(groupId, this.selectedStageId);
        alert('Jogos resetados com sucesso');
      } catch (error) {
        console.error('Erro ao resetar jogos', error);
      }
    },
    async gerarJogos() {
      if (!this.selectedStageId) return;

      try {
        await gameService.generateGamesForStage(this.selectedStageId);
        alert('Jogos gerados para a etapa com sucesso');
      } catch (error) {
        console.error('Erro ao gerar jogos para a etapa', error);
      }
    },
    async onDragEnd() {
      const updateOrder = this.groupPlayers.map((player, index) => ({
        groupId: this.expandedGroupId,
        playerId: player.id,
        order: index,
      }));

      console.log(updateOrder);

      try {
        await groupPlayerService.updatePlayersOrder(this.expandedGroupId, updateOrder);
      } catch (error) {
        console.error('Erro ao atualizar a ordem dos jogadores:', error);
      }
    },
    async onGroupDragEnd() {
      const newOrder = this.groups.map((group, index) => ({
        groupId: group.id,
        order: index,
      }));

      try{
        await groupService.updateGroupsOrder(newOrder);
      } catch (error) {
        console.error('Erro ao atualizar a ordem do group', error);
      }
    },
    confirmDeleteGroup(groupId) {
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja deletar este grupo?';
      this.actionToConfirm = this.deleteGroup;
      this.actionData = groupId;
    },
    confirmGenerateGames(groupId) {
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja gerar jogos para este grupo?';
      this.actionToConfirm = this.generateGames;
      this.actionData = groupId;
    },
    confirmDeleteGames(groupId) {
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja limpar os jogos deste grupo?';
      this.actionToConfirm = this.deleteGames;
      this.actionData = groupId;
    },
    confirmRemovePlayer(playerId) {
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja remover este jogador do grupo?';
      this.actionToConfirm = this.removePlayer;
      this.actionData = playerId;
    },
    goBack() {
      this.$router.push('/admin');
    },
    confirmAction() {
      if (this.actionToConfirm) {
        this.actionToConfirm(this.actionData);
      }
      this.showModal = false;
    },
    cancelAction() {
      this.showModal = false;
    },
  },
  watch: {
    selectedStageId() {
      this.loadGroups();
      this.loadPlayers()
    },
  },
};
</script>

<style scoped>
.group-management {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: #f0f4f7;
}

.group-management h2 {
  margin-bottom: 1.5rem;
  color: #003366;
}

.back-button {
  margin-bottom: 1.5rem;
  padding: 0.5rem 1rem;
  background-color: #0056b3;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.back-button:hover {
  background-color: #003366;
}

.generate-games-button {
  margin-bottom: 1.5rem;
  margin-left: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #b3a400;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.generate-games-button:hover {
  background-color: #807404;
}

.form-container {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.form-container input,
.form-container select {
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.create-button {
  padding: 0.5rem 1rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.create-button:hover {
  background-color: #218838;
}

.group-list {
  width: 100%;
  max-width: 600px;
  margin-bottom: 1.5rem;
}

.group-block {
  margin-bottom: 0.5rem;
}

.group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: grab;
}

.group-item:active {
  cursor: grabbing;
  opacity: 0.8;
}

.group-actions {
  display: flex;
  gap: 0.5rem;
}

.delete-button,
.view-button,
.generate-button,
.delete-games-button {
  padding: 0.3rem 0.6rem;
  border-radius: 8px;
  border: none;
  color: white;
  cursor: pointer;
}

.delete-button {
  background-color: #e74c3c;
}

.delete-button:hover {
  background-color: #c0392b;
}

.view-button {
  background-color: #007bff;
}

.view-button:hover {
  background-color: #0056b3;
}

.generate-button {
  background-color: #07ccd3;
}

.generate-button:hover {
  background-color: #069ca1;
}

.delete-games-button {
  background-color: #f5c908;
}

.delete-games-button:hover {
  background-color: #c9a402;
}

.group-details {
  padding: 1rem;
}

.player-list {
  list-style: none;
  padding: 0;
}

.player-item {
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  user-select: none;
}

.drag-handle{
  cursor: grab;
  margin-right: 0.5rem;
  font-size: 1.2rem;
}

.remove-button {
  position: absolute;
  right: 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.3rem 0.6rem;
  border-radius: 8px;
  cursor: pointer;
}

.remove-button:hover {
  background-color: #c0392b;
}

.add-player-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.player-select {
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.add-button {
  padding: 0.5rem 1rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.add-button:hover {
  background-color: #218838;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
}

.confirm-button {
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #218838;
}

.cancel-button {
  background-color: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #c0392b;
}

.fade-expand-enter-active,
.fade-expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 1000px;
}

.fade-expand-enter-from,
.fade-expand-leave-to {
  max-height: 0;
  opacity: 0;
}

@media (max-width: 425px) {
  .form-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .group-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .group-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .group-item button {
    width: 100%;
    text-align: center;
  }
}
</style>
